var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr','text-align':'left'})},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.rowStatus),expression:"rowStatus"}],staticClass:"new"},[_vm._v("NEW")]),_c('span',[_vm._v(_vm._s(_vm.cellValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }